import baseAPI from "@/http";

const router = "api/MunicipiosEixos";

export const municipioEixoApi = {
  create: (city) => baseAPI.post(`${router}/cadastrar-municipio-eixo`, city),
  listar: () => baseAPI.get(`${router}/listar-municipio-eixo`),
  update: (city) => baseAPI.put(router, city),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`),
  listNames: () => baseAPI.get(router + "/get-nomes"),
  getTasksReport: (id) => baseAPI.get(`${router}/relatorio-tarefa/${id}`),
  atualizarEmLote: (municipios) =>
    baseAPI.put(`${router}/atualizar-municipios-eixos-lote`, municipios),
};
